import http from '@/http'
import { SetUseful, Page, FeedbackCreate, QuestionPageParam } from '@/types/type'

// 问题汇总导航
export const getCategories = function() {
    return http.post('/v2/res/user/pms/question/public/tree')
}
// 问题汇总列表
export const getResourceList = function(id: string) {
    return http.post('/v2/res/user/pms/question/public/list', { categoryId: id })
}
// 问题汇总获取栏目id
export const getCategory = function(id: string) {
    return http.post('/v2/res/user/pms/question/public/getCategory', { id: id })
}
// 问题汇总列表详情
export const getQuestionDetail = function(id?: any) {
    return http.post('/v2/res/user/pms/question/public/detail', { id })
}
// 问题汇总列表登录详情
export const questionLoginDetail = function(id?: any) {
    return http.post('/v2/res/user/pms/question/loginDetail', { id })
}
// 正文评价是否有用
export const questionSetUseful = function(params: SetUseful) {
    return http.post('/v2/res/user/pms/question/setUseful', params)
}
// 视频列表
export const videoPage = function(params: Page) {
    return http.post('/v2/res/user/pms/video/public/page', params)
}
// 视频详情
export const videoDetail = function(id: string) {
    return http.post('/v2/res/user/pms/video/public/detail', { id })
}
// 视频登录详情
export const videoLoginDetail = function(id: string) {
    return http.post('/v2/res/user/pms/video/loginDetail', { id })
}
// 视频评价是否有用
export const videoSetUseful = function(params: SetUseful) {
    return http.post('/v2/res/user/pms/video/setUseful', params)
}
// 新手专区，获取栏目-资源接口
export const newbiesList = function() {
    return http.post('/v2/res/user/pms/newbies/public/list')
}
// 新手专区，获取栏目-资源接口
export const newbiesDetail = function(id: string) {
    return http.post('/v2/res/user/pms/newbies/public/detail', { id })
}
// 文档下载
export const downList = function() {
    return http.post('/v2/res/user/pms/down/list')
}
// 文档下载详情
export const downDetail = function(id: string) {
    return http.post('/v2/res/user/pms/down/detail', {id: id})
}
// 提交问题反馈
export const feedbackCreate = function(params: FeedbackCreate) {
    return http.post('/v2/res/user/pms/feedback/create', params)
}
// 获取全局搜索列表
export const baseSearch = function(params: String | undefined) {
    return http.post('/v2/res/user/pms/base/public/search', { title: params })
}
// 获取分享信息
export const baseShareDetail = function(id: String) {
    return http.post('/v2/res/user/pms/base/public/shareDetail', { id: id })
}
// 分页获取问题汇总资源信息
export const questionPage = function(params: QuestionPageParam) {
    return http.post('/v2/res/user/pms/question/public/page', params)
}
// 分页查询视频列表
export const videoSelectPage = function(params: QuestionPageParam) {
    return http.post('/v2/res/user/pms/video/public/selectPage', params)
}
// 新手专区详情
export const newbiesLoginDetail = function(id: string) {
    return http.post('/v2/res/user/pms/newbies/loginDetail', { id })
}
